import React from 'react'
import profileService from '../Service/profileService'
import DoctorProfiles from './doctor_profile'
import DoctorProfile from '../DoctorProfile/index'
import DetailDoctorService from '../Service/DetailDoctorService'
import UserProfiles from './user_profile'
import AdminProfiles from './admin_profile'
import { config, storage} from '../Config/config'


export default class index extends React.Component {
    editBio = {
        id: "",
        biodata_id: "",
        name: "",
        mobile: "",
        tgl_lahir: "",
        image: "",
        image_path: "",
        modified_on: new Date()

    }
    editAkun = {
        id: "",
        email: "",
        password: "",
        otp: "",
        modified_on: new Date()
    }
    t_password = {
        id: "",
        password: "",
        password_confirm: "",
        new_password: "",
        new_password_confirm: "",
        reset_for: "",
        modified_on: new Date()
    }
    constructor() {
        super()
        this.state = {
            List: [],
            List_user: [],
            List_biodata: [],
            List_biodata_full: [],
            ModelBio: this.editBio,
            ModelAkun: this.editAkun,
            ModelPassword: this.t_password,
            biodata_id: "",
            spesialis: "",
            setShowBio: false,
            setShowEmail: false,
            setShowOtp: false,
            setShowPassNow: false,
            setShowPassNew: false,
            setShowPhoto: false,
            href: "",
            progress:"",
            uploadTask:"",
            file:"",
            snnapshot_state:"",
            type: "password",
            timeout: null,
            treatment: [],
            riwayat: [],
            errors: {},
        }
    }

    loadList = async () => {
        if (localStorage.getItem(config.role) == "ROLE_DOKTER") {
            /*
            const respon = await profileService.getBio(localStorage.getItem(config.username))
            if (respon.success) {
          
                this.setState({
                    biodata_id: respon.result.biodata_id
                })
            }
            const respon_spesialisasi = await profileService.getSpes(this.state.biodata_id)
            if (respon_spesialisasi.success) {
                this.setState({
                    //spesialis: respon_spesialisasi.result.major
                })
            }
            const respon_treatment = await profileService.getTreat(this.state.biodata_id)
            if (respon_treatment.success) {
                this.setState({
                    treatment: respon_treatment.result
                })
            }
            const respon_riwayat = await profileService.getRiwayat(this.state.biodata_id)
            if (respon_riwayat.success) {
                this.setState({
                    riwayat: respon_riwayat.result
                })
            }
            */
            const respon = await profileService.getBio(localStorage.getItem(config.userid))
            if (respon.success){
                this.setState({
                    List_user: respon.result,
                    List_biodata: respon.result.user_biodata[0],
                    //List_biodata_full:respon_bio.result       
                })
              
            this.setState({
                ModelBio: {
                    ...this.state.ModelBio,
                    ["name"]: this.state.List_biodata.fullname,
                    //["mobile"]: ((this.state.List_biodata.mobile_phone)).slice(2, 13),
                    ["tgl_lahir"]: this.state.List_biodata.tanggal_lahir,
                    ["image"]: this.state.List_biodata.image,
                    ["image_path"]: this.state.List_biodata.image_path,
                    ["id"]: localStorage.getItem(config.userid),
                    ["biodata_id"]: this.state.List_biodata._id
                }
            })
            }


        } else if (localStorage.getItem(config.role) == "ROLE_PASIEN") {
            const respon = await profileService.getBio(localStorage.getItem(config.userid))
            if (respon.success) {
                this.setState({
                    List_user: respon.result,
                    List_biodata: respon.result.user_biodata[0],
                    //List_biodata_full:respon_bio.result       
                })
                // var date = new Date(this.state.List_biodata.tanggal_lahir)
                // var month = date.toLocaleString('default',{month:'long'})
                // var year = date.getFullYear()
                // var day = date.getUTCDay()
                // date = day+"-" + month + "-"+year
                this.setState({
                    ModelAkun: {
                        ...this.state.ModelAkun,
                        ["email"]: this.state.List_user.email,
                        ["password"]: this.state.List_user.password,
                        ["id"]: this.state.List_user.email
                    }
                })
                this.setState({
                    ModelBio: {
                        ...this.state.ModelBio,
                        ["name"]: this.state.List_biodata.fullname,
                        ["mobile"]: ((this.state.List_biodata.mobile_phone)).slice(2, 13),
                        ["tgl_lahir"]: this.state.List_biodata.tanggal_lahir,
                        ["image"]: this.state.List_biodata.image,
                        ["image_path"]: this.state.List_biodata.image_path,
                        ["id"]: localStorage.getItem(config.userid),
                        ["biodata_id"]: this.state.List_biodata._id
                    }
                })
                this.setState({
                    ModelPassword: {
                        ...this.state.ModelPassword,
                        ["id"]: this.state.List_user._id
                    }
                })

            }
            //console.log(this.state.List_biodata_full)

        } else if (localStorage.getItem(config.role) == "ROLE_ADMIN") {

            const respon = await profileService.getBio(localStorage.getItem(config.userid))
            if (respon.success) {
                this.setState({
                    List_user: respon.result,
                    List_biodata: respon.result.user_biodata[0],
                    //List_biodata_full:respon_bio.result       
                })
                this.setState({
                    ModelAkun: {
                        ...this.state.ModelAkun,
                        ["email"]: this.state.List_user.email,
                        ["password"]: this.state.List_user.password,
                        ["id"]: this.state.List_user.email
                    }
                })
                this.setState({
                    ModelBio: {
                        ...this.state.ModelBio,
                        ["name"]: this.state.List_biodata.fullname,
                        ["mobile"]: ((this.state.List_biodata.mobile_phone)).slice(2, 13),
                        ["tgl_lahir"]: this.state.List_biodata.tanggal_lahir,
                        ["image_path"]: this.state.List_biodata.image_path,
                        ["id"]: localStorage.getItem(config.userid),
                        ["biodata_id"]: this.state.List_biodata._id
                        

                    }
                })
                this.setState({
                    ModelPassword: {
                        ...this.state.ModelPassword,
                        ["id"]: this.state.List_user._id
                    }
                })
            }
            //console.log(this.state.List_biodata_full)
        }
    }
    componentDidMount() {
        this.loadList()
    }


    changehandler = name => ({ target: { value } }) => (
        this.setState({
            ModelBio: {
                ...this.state.ModelBio,
                [name]: value
            }
        })
    )

    changehandleremail = name => ({ target: { value } }) => (
        this.setState({
            ModelAkun: {
                ...this.state.ModelAkun,
                [name]: value
            }
        })
    )

    editBiohandler = async () => {
        let name = {}
        let mobile = {}
        let fields = this.state.ModelBio
        let errors = {}
        let formIsValid = true
        const respon = await profileService.getuserfullname(fields["name"])
        const responPhone = await profileService.getuserphone(fields["mobile"])
        if (respon.success) {
            name = respon.result
            mobile = responPhone.result

            if (name.length != 0) {
                formIsValid = false;
                errors["name"] = "Name already exist";

            }

            if (!fields["name"]) {
                formIsValid = false;
                errors["name"] = "Cannot be empty";
            }

            if (mobile.length != 0) {
                formIsValid = false;
                errors["mobile"] = "Mobile Phone already exist";

            }

            if (!fields["mobile"]) {
                formIsValid = false;
                errors["mobile"] = "Cannot be empty";
            }
            if ((fields["mobile"]).length > 12) {
                formIsValid = false;
                errors["mobile"] = "Only accept number max 12 character";
            }

            this.setState({
                errors: errors,
            })
            return formIsValid
        }
    }

    saveHandlerBio = async () => {
        if (await this.editBiohandler()) {
            const respon = await profileService.updData(this.state.ModelBio)
            if (respon.success) {
                localStorage.setItem(config.username, this.state.ModelBio.name)
                window.location = '/profile'
                this.loadList()
                this.setState({
                    ModelBio: {},
                    setShowBio: false
                })
            }
        }
    }

    addHandlerBio = async () => {
        this.setState({
            //Mode: "create",
            setShowBio: true,
        })
    }

    cancelHandlerBio = async () => {
        this.setState({
            //Mode: "",
            setShowBio: false,
            errors: {},
            ModelBio: {
                ...this.state.ModelBio,
                ["name"]: this.state.List_biodata.fullname,
                ["mobile"]: ((this.state.List_biodata.mobile_phone)).slice(2, 13)

            }
        })
    }

    addHandlerEmail = async () => {
        this.setState({
            //Mode: "create",
            setShowEmail: true
        })
    }

    cancelHandlerEmail = async () => {
        this.setState({
            //Mode: "",
            setShowEmail: false,
            errors: {},
            ModelAkun: {
                ...this.state.ModelAkun,
                ["email"]: this.state.List_user.email,
            }
        })
    }

    editEmailhandler = async () => {
        let email = {}
        let fields = this.state.ModelAkun
        let errors = {}
        let formIsValid = true
        const respon = await profileService.getuseremail(fields["email"])
        if (respon.success) {
            email = respon.result

            if (email.length != 0) {
                formIsValid = false;
                errors["email"] = "email already exist";

            }

            if (typeof fields["email"] !== "undefined") {
                // let lastAtPos = fields["email"].lastIndexOf('@');
                // let lastDotPos = fields["email"].lastIndexOf('.');

                // if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
                //     formIsValid = false;
                //     errors["email"] = "Email is not valid";
                // }
               var filter = /^([w-]+(?:.[w-]+)*)@((?:[w-]+.)*w[w-]{0,66}).([com net org]{3}(?:.[a-z]{6})?)$/i
               if((fields["email"]).match(filter)){
                    formIsValid = true;
                }
               else{
                formIsValid = false;
                 errors["email"] = "Email is not valid";
               }
            }

            if (!fields["email"]) {
                formIsValid = false;
                errors["email"] = "Cannot be empty";
            }
            this.setState({ errors: errors })
            return formIsValid
        }
    }

    otpHandler = async () => {
        if (await this.editEmailhandler()) {
            const respon = await profileService.getotp(this.state.ModelAkun.email)
            if (respon.success) {
                localStorage.setItem(config.otp, respon.result)
                this.setState({
                    setShowOtp: true,
                    setShowEmail: false,
                    timeout: setTimeout(function () {
                        document.getElementById('buttotp').style.display = 'block';
                        localStorage.setItem(config.otp, "")
                    }, 30000)
                })
            }

        }

    }

    resendotpHandler = async () => {
        document.getElementById('buttotp').style.display = 'none';
        const respon = await profileService.getotp(this.state.ModelAkun.email)
        if (respon.success) {
            localStorage.setItem(config.otp, respon.result)
            this.setState({
                    timeout: setTimeout(function () {
                    document.getElementById('buttotp').style.display = 'block';
                    localStorage.setItem(config.otp, "")
                }, 30000)
            })
        }


    }

    otpValidhandler = async () => {
        let fields = this.state.ModelAkun
        let errors = {}
        let formIsValid = true

        if (localStorage.getItem(config.otp) == "") {
            formIsValid = false;
            errors["otp"] = "Token Expired"
        } else if (fields["otp"] != localStorage.getItem(config.otp)) {
            formIsValid = false;
            errors["otp"] = "Wrong Token"
        } else if (localStorage.getItem(config.otp) == fields["otp"]) {
            formIsValid = true;
        }

        if (!fields["otp"]) {
            formIsValid = false;
            errors["otp"] = "Cannot be empty";
        }

        this.setState({ errors: errors })
        return formIsValid

    }

    updEmail = async () => {
        if (await this.otpValidhandler()) {
            const respon = await profileService.updEmail(this.state.ModelAkun)
            if (respon.success) {
                alert('please relogin')
                this.loadList()
                this.setState({
                    ModelBio: {},
                    setShowOtp: false
                })
                this.onLogout()
            }
        }
    }

    cancelHandlerOtp = async () => {
        this.setState({
            //Mode: "",
            setShowOtp: false,
            errors: {},
            ModelAkun: {
                ...this.state.ModelAkun,
                ["otp"]: "",
                ["email"]: this.state.List_user.email,
            }

        })
        clearTimeout(this.state.timeout)
    }

    oldpasswordhandler = async () => {
        let fields = this.state.ModelPassword
        let errors = {}
        let formIsValid = true


        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "Cannot be empty";
        }
        if (!fields["password_confirm"]) {
            formIsValid = false;
            errors["password_confirm"] = "Cannot be empty";
        }

        if (fields["password"] != fields["password_confirm"]) {
            if (fields["password_confirm"] != this.state.ModelAkun.password) {
                formIsValid = false;
                errors["password_confirm"] = "Password not match"
            }
            if (fields["password"] != this.state.ModelAkun.password) {
                formIsValid = false;
                errors["password"] = "Password not match"
            }
        }
        if (fields["password"] == fields["password_confirm"] && (fields["password"].length != 0 && fields["password_confirm"].length != 0)) {
            formIsValid = true
            this.setState({
                setShowPassNew: true,
                href: "#edit-password-new"
            })
        }

        this.setState({
            setShowPassNow: false,
            errors: errors,

        })
        return formIsValid

    }

    addOldPass = async () => {
        this.setState({
            //Mode: "create",
            setShowPassNow: true
        })
    }

    cancelOldPass = async () => {
        this.setState({
            //Mode: "",
            setShowPassNow: false,
            errors: {},
            ModelPassword: {
                ...this.state.ModelPassword,
                ["password"]: "",
                ["password_confirm"]: ""
            }
        })
    }

    cancelNewPass = async () => {
        this.setState({
            //Mode: "",
            setShowPassNew: false,
            errors: {},
            ModelPassword: {
                ...this.state.ModelPassword,
                ["new_password"]: "",
                ["new_password_confirm"]: ""
            }
        })
    }
    changehandlerpassword = name => ({ target: { value } }) => (
        this.setState({
            ModelPassword: {
                ...this.state.ModelPassword,
                [name]: value
            }
        })
    )

    newpasswordhandler = async () => {
        let fields = this.state.ModelPassword
        let errors = {}
        let formIsValid = true

        if (!fields["new_password"]) {
            formIsValid = false;
            errors["new_password"] = "Cannot be empty";
        }
        if (!fields["new_password_confirm"]) {
            formIsValid = false;
            errors["new_password_confirm"] = "Cannot be empty";

        }
        if (fields["new_password"] != fields["new_password_confirm"]) {
            if (fields["new_password_confirm"] != this.state.ModelAkun.password) {
                formIsValid = false;
                errors["new_password_confirm"] = "Password not match"
            }
            if (fields["new_password"] != this.state.ModelAkun.password) {
                formIsValid = false;
                errors["new_password"] = "Password not match"
            }
        }
        if ((fields["new_password"] == fields["new_password_confirm"]) && (fields["new_password_confirm"].length != 0 && fields["new_password"].length != 0)) {
            var constraint = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
            if (fields["new_password_confirm"] == this.state.ModelAkun.password) {
                alert("Password must not same like your previous one")
                formIsValid = false
            } else {
                if ((fields["new_password_confirm"]).match(constraint)) {
                    formIsValid = true
                } else {
                    alert("Your password must at least include 1 upper,lower case,number,special charakter and must 8 character length")
                    formIsValid = false
                }
            }
        }

        this.setState({
            errors: errors
        })
        return formIsValid
    }
    updPassword = async () => {
        if (await this.newpasswordhandler()) {
            const respon = await profileService.updPassword(this.state.ModelPassword)
            const responres = await profileService.resPassword(this.state.ModelPassword)
            if (respon.success) {
                alert('please relogin')
                this.loadList()
                this.setState({
                    ModelAkun: {},
                    ModelBio: {},
                    ModelPassword: {},
                    setShowPassNew: false
                })
                this.onLogout()
            }
        }
    }

    tooglehandler = async ({ target: { background } }) => {
        if (background == onclick) {
            if (this.state.type == "password") {
                this.setState({
                    type: "text"
                })
            } else if (this.state.type == "text") {
                this.setState({
                    type: "password"
                })
            }
        }
    }
    
    imagehandle = a => {
        if (a.target.files[0]) {
            this.setState({
         file: a.target.files[0]
                
            })
        }
    }
    
    handleUpload = () => {
        let errors = {}
        if(this.state.file != "" ){
            const {file} = this.state
            const uploadTask = storage.ref(`images/${file.name}`).put(file)
            this.setState({
                uploadTask:uploadTask
            })
            uploadTask.on(
                "state_changed",
                snapshot => { 
                    const progress = Math.round((snapshot.bytesTransferred/snapshot.totalBytes)*100)
                    this.setState({
                        progress:progress,
                        snnapshot_state:snapshot.state
                    })
                    
                },
                error => {
                    console.log(error)
                },
                async () => {
                    await storage
                        .ref("images")
                        .child(file.name)
                        .getDownloadURL()
                        .then(URL => {
                            //var urlParams = URL
                            //console.log(urlParams)
                            //urlParams = urlParams.slice((urlParams.indexOf('images') + 9))
                            // var image_url = urlParams.slice(0 , (urlParams.indexOf('images') + 9))
                            this.setState({
                                ModelBio:{
                                ...this.state.ModelBio,
                                image:file.name,
                                image_path: URL
            
                            }
                            },()=>{localStorage.setItem(config.image_path, this.state.ModelBio.image_path)})
                        })
                       
                    }
            )
        }else{
        errors["photo"] = "File cannot be empty"
            }
            this.setState({errors: errors})
    }

    // photohandler = async () => {
    //     let fields = this.state.ModelBio
    //     let errors = {}
    //     let formIsValid = true

    //     if (!fields["image"]) {
    //         formIsValid = false;
    //         errors["photo"] = "cannot be empty"
    //     }
    //     this.setState({ errors: errors })
    //     return formIsValid

    // }

    updPhoto = async () => {
        let errors = {}
        if(this.state.progress != 100){
            errors["photo"] = "cant save upload still on progress"
        }else{
            const respon = await profileService.updPhoto(this.state.ModelBio)
            console.log(respon)
            if (respon.success) {
                this.loadList()
                this.setState({
                    ModelBio: {},
                    setShowPhoto: false
                })
                window.location = "/profile"
            }
        }
        this.setState({errors: errors})
    }
    editPhoto = async () => {
        this.setState({
            //Mode: "create",
            setShowPhoto: true,
            file:"",
            ModelBio: {
                ...this.state.ModelBio,
                ["image"]:""
            }
        })
    }

    cancelPhoto = async () => {
        this.setState({
            //Mode: "",
            setShowPhoto: false,
            errors: {},
            ModelBio: {
                ...this.state.ModelBio,
                ["image"]: this.state.List_biodata.image,
                ["image_path"]: this.state.List_biodata.image_path
            },
            progress:0
        })
        if(this.state.snnapshot_state == "running"){
        this.state.uploadTask.cancel()
        }
    }

    onLogout = () => {
        localStorage.clear()
        window.location = '/'
    }


    render() {
        const { treatment, spesialis, riwayat, ModelBio, setShowBio,
            setShowEmail, ModelAkun, setShowOtp, setShowPassNow,setShowPhoto, setShowPassNew, ModelPassword,
            errors, href, type,progress } = this.state
        if (localStorage.getItem(config.role) == "ROLE_DOKTER") {
            return (
                <div>
                    {/* //{JSON.stringify(this.state.Model)} */}
                    <DoctorProfile
                    //treatment={treatment}
                    // spesialis={spesialis}
                    // riwayat={riwayat} 
                    setShowPhoto = {setShowPhoto}
                    updPhoto={this.updPhoto}
                    editPhoto = {this.editPhoto}
                    cancelPhoto = {this.cancelPhoto}
                    handleUpload = {this.handleUpload}
                    imagehandle = {this.imagehandle}
                    progress = {progress}
                    errors={errors}
                    ModelBio={ModelBio}
                    />
                </div>

            )
        } else if (localStorage.getItem(config.role) == "ROLE_PASIEN") {
            return (
                <div>
                    <UserProfiles
                         ModelBio={ModelBio}
                         ModelAkun={ModelAkun}
                         ModelPassword={ModelPassword}
                         setShowBio={setShowBio}
                         setShowEmail={setShowEmail}
                         setShowOtp={setShowOtp}
                         setShowPassNow={setShowPassNow}
                         setShowPassNew={setShowPassNew}
                         setShowPhoto = {setShowPhoto}
                         href={href}
                         type={type}
                         progress = {progress}
                         updPhoto={this.updPhoto}
                         editPhoto = {this.editPhoto}
                         cancelPhoto = {this.cancelPhoto}
                         handleUpload = {this.handleUpload}
                         imagehandle = {this.imagehandle}
                         updPassword={this.updPassword}
                         newpasswordhandler={this.newpasswordhandler}
                         cancelNewPass={this.cancelNewPass}
                         changehandlerpassword={this.changehandlerpassword}
                         addOldPass={this.addOldPass}
                         oldpasswordhandler={this.oldpasswordhandler}
                         cancelOldPass={this.cancelOldPass}
                         changehandler={this.changehandler}
                         addHandlerBio={this.addHandlerBio}
                         cancelHandlerBio={this.cancelHandlerBio}
                         editBiohandler={this.editBiohandler}
                         saveHandlerBio={this.saveHandlerBio}
                         onLogout={this.onLogout}
                         addHandlerEmail={this.addHandlerEmail}
                         cancelHandlerEmail={this.cancelHandlerEmail}
                         otpHandler={this.otpHandler}
                         changehandleremail={this.changehandleremail}
                         resendotpHandler={this.resendotpHandler}
                         updEmail={this.updEmail}
                         cancelHandlerOtp={this.cancelHandlerOtp}
                         tooglehandler={this.tooglehandler}
                         errors={errors} 
                    />

                </div>
            )
        } else if (localStorage.getItem(config.role) == "ROLE_ADMIN") {
            return (
                <div>
                    <AdminProfiles
                        ModelBio={ModelBio}
                        ModelAkun={ModelAkun}
                        ModelPassword={ModelPassword}
                        setShowBio={setShowBio}
                        setShowEmail={setShowEmail}
                        setShowOtp={setShowOtp}
                        setShowPassNow={setShowPassNow}
                        setShowPassNew={setShowPassNew}
                        setShowPhoto = {setShowPhoto}
                        href={href}
                        type={type}
                        progress = {progress}
                        updPhoto={this.updPhoto}
                        editPhoto = {this.editPhoto}
                        cancelPhoto = {this.cancelPhoto}
                        handleUpload = {this.handleUpload}
                        imagehandle = {this.imagehandle}
                        updPassword={this.updPassword}
                        newpasswordhandler={this.newpasswordhandler}
                        cancelNewPass={this.cancelNewPass}
                        changehandlerpassword={this.changehandlerpassword}
                        addOldPass={this.addOldPass}
                        oldpasswordhandler={this.oldpasswordhandler}
                        cancelOldPass={this.cancelOldPass}
                        changehandler={this.changehandler}
                        addHandlerBio={this.addHandlerBio}
                        cancelHandlerBio={this.cancelHandlerBio}
                        editBiohandler={this.editBiohandler}
                        saveHandlerBio={this.saveHandlerBio}
                        onLogout={this.onLogout}
                        addHandlerEmail={this.addHandlerEmail}
                        cancelHandlerEmail={this.cancelHandlerEmail}
                        otpHandler={this.otpHandler}
                        changehandleremail={this.changehandleremail}
                        resendotpHandler={this.resendotpHandler}
                        updEmail={this.updEmail}
                        cancelHandlerOtp={this.cancelHandlerOtp}
                        tooglehandler={this.tooglehandler}
                        errors={errors}  />
                </div>
            )
        }

    }
}